import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { canGalleryPhotoPublish, layoutActions, ModalsType } from '@Techedge/digitalportal-shared'
import { useIntl } from 'react-intl'
import {
    LuxModalFullScreen,
    LuxPhotoFullScreen,
    LuxCtaGroupWrapper,
    useWindowResize,
} from '@lux/wardrobe-lib'
import './SavePicture.scss'
import {
    approvePhoto,
    deletePhoto,
    getPhotoDetails,
    publishPhoto,
    rejectPhoto,
    SavePictureActions,
    sendInApprovalPhoto,
    setPhotoDetials,
    showToastSavePictureSuccess,
    updatePhotoTagList,
} from '../redux/actions/save-picture'
import PhotoDetailsUpload from '../components/ActivityExecution/Action/Photo/PhotoDetailsUpload'
import PhotoSlider from '../components/SavePicture/PhotoSlider'
import DialogUploadPhoto from '../components/ActivityExecution/Action/Photo/DialogUploadPhoto'
import DialogConfirmDeletePhoto from '../components/ActivityExecution/Action/Photo/DialogConfirmDeletePhoto'
import DialogConfirmPublishPhoto from '../components/SavePicture/DialogConfirmPublishPhoto'
import { TaskPhotoUpload } from '../models/projects-service'
import { uploadActivityTaskPhoto } from '../redux/actions/activity-execution'
import { usePhotoFullScreen } from '../hooks/usePhotoFullScreen'
import { getCtaConfig, getCtaNewPhotoConfig } from '../models/save-picture-cta-config'
import PhotoDetails from '../components/SavePicture/PhotoDetails'
import { IPhotoDetails } from '../models/photo'
import { SAVE_PICTURE_REDUCER_NAMESPACE } from '../redux/reducers/save-picture'
import { newActivityCreationError } from '../redux/actions/activity-creation'
import { downloadPhoto } from '../utils/commonFunctions'
import { useUploadPhoto } from '../hooks/useUploadPhoto'
import { MenuItem } from 'primereact/menuitem'
import AlbumListDialog from '../components/Gallery/AlbumListDialog/AlbumListDialog'
import { setReloadParentData } from '../redux/actions/common'
import { getPhotoTagList } from '../redux/actions/filters'
import { FILTERS_REDUCER_NAMESPACE } from '../redux/reducers/filters'

const SavePicture = (props: {
    tagListApi: string[]
    imageProps: any
    photoDetails: IPhotoDetails
    modalLoading: boolean
    getPhotoTagList: () => void
    updatePhotoTagList: (
        params: {
            attachmentId: string
            tags: { name: string; x: number; y: number }[]
        },
        callback: () => void
    ) => void
    onClose: () => void
    uploadActivityTaskPhoto: (photos: TaskPhotoUpload[], callback: () => void) => void
    approvePhoto: (attachmentIds: string[]) => void
    rejectPhoto: (attachmentIds: string[]) => void
    publishPhoto: (attachmentIds: string[]) => void
    sendInApprovalPhoto: (attachmentIds: string[]) => void
    deletePhoto: (attachmentIds: string[], callback: () => void) => void
    getPhotoDetails: (id: string) => void
    newActivityCreationError: (err: string) => void
    setModalLoading: (loading) => void
    goToReferenceTask: (id: string, storeId: string) => void
    showToastSavePictureSuccess: () => void
    setReloadParentData: () => void
}) => {
    const {
        imageProps,
        photoDetails,
        tagListApi,
        modalLoading,
        getPhotoTagList,
        updatePhotoTagList,
        onClose,
        uploadActivityTaskPhoto,
        approvePhoto,
        rejectPhoto,
        publishPhoto,
        sendInApprovalPhoto,
        deletePhoto,
        getPhotoDetails,
        setModalLoading,
        goToReferenceTask,
        showToastSavePictureSuccess,
        setReloadParentData,
    } = props
    const {
        projectTitle,
        projectType,
        projectId,
        uploadStoreId = '',
        isUpload,
        imageList = [],
        id,
        executionProjectId,
    } = imageProps

    const [dialogConfirmDeletePhotoVisible, setDialogConfirmDeletePhotoVisible] =
        useState<boolean>(false)
    const [dialogConfirmPublishPhotoVisible, setDialogConfirmPublishPhotoVisible] =
        useState<boolean>(false)
    const [mobileImageList, setMobileImageList] = useState<any[]>([])
    const [localProjectid, setLocalProjectId] = useState(projectId)
    const [albumListDialogVisible, setAlbumListDialogVisible] = useState<boolean>(false)

    const intl = useIntl()
    const isMobile = useWindowResize()

    const componentClass = 'smart-modals-save-picture'

    const breadcrumbs: MenuItem[] = [
        {
            label: intl.formatMessage({
                id: 'modals.gallery.detail.save_picture.breadcrumb',
                defaultMessage: 'Save Picture',
            }),
        },
    ]

    const {
        editImageExt,
        editImageId,
        uploadedImageList,
        setUploadedImageList,
        selectedImage,
        setSelectedImage,
        selectedImageInfo,
        enabledEdit,
        enabledTag,
        tagList,
        newTagPosition,
        tagOnImageList,
        onRemoveTag,
        onNewTagPosition,
        onCloseFullScreen,
        previousImage,
        nextImage,
        slide,
        setSlide,
        editLoading,
        setEditLoading,
        onExpandImage,
        onTag,
        onEdit,
        showPhotoFullScreen,
    } = usePhotoFullScreen({
        updatePhotoTagList,
        getPhotoTagList,
        tagPhotoDetails: photoDetails?.tags?.map((tag) => ({ tag: tag.name, x: tag.x, y: tag.y })),
        tagListApi,
        initImageList: imageList,
    })
    const [storeId, setStoreId] = useState<Record<string, string>>({
        [uploadedImageList[slide]?.attachmentId]: uploadStoreId,
    })

    const [macroareaMap, setMacroareaMap] = useState<Record<string, string>>({
        [uploadedImageList[slide]?.attachmentId]: uploadedImageList[slide]?.macroarea || '',
    })
    const [fixtureCountMap, setFixtureCountMap] = useState<Record<string, number>>({
        [uploadedImageList[slide]?.attachmentId]: uploadedImageList[slide]?.fixtureCount || 1,
    })

    const onFormatError = () => {
        newActivityCreationError(
            intl.formatMessage({
                id: 'modals.new.activity.section.main.info.project.cover.format.error',
                defaultMessage:
                    'Selected image format cannot be processed, please use images with one of the following formats: .apng,.avif,.gif,.jpg,.jpeg,.jfif,.pjpeg,.pjp,.png,.svg,.webp, .bmp,.ico,.cur,.tif,.tiff',
            })
        )
    }

    const onSizeError = () => {
        newActivityCreationError(
            intl.formatMessage({
                id: 'modals.new.activity.section.main.info.project.cover.size.error',
                defaultMessage: 'Selected image exceeds the size limit of 20MB',
            })
        )
    }

    const {
        imagePosition,
        setImagePosition,
        dialogUploadPhotoVisible,
        setDialogUploadPhotoVisible,
        onFileChange,
        uploadImageList,
        onEditImage,
    } = useUploadPhoto({
        uploadedImageList,
        setUploadedImageList,
        setModalLoading,
        onFormatError,
        onSizeError,
        onUploadDone: () => null,
        setSelectedImage,
    })

    const onEditDone = (blob: Blob) => {
        const file = new File([blob], selectedImageInfo.title)
        const reader: any = new FileReader()
        reader.onloadend = async () => {
            setImagePosition(slide + 1)
            uploadImageList({
                files: [
                    {
                        url: reader.result.toString(),
                        name: file.name,
                        fileObj: file,
                    },
                ],
                editImagePosition: slide + 1,
            })
            setSelectedImage(reader.result.toString())
        }
        if (!editImageId) {
            reader.readAsDataURL(blob)
        } else {
            onEditImage(blob, `${selectedImageInfo.title}.${editImageExt}`, editImageId, slide + 1)
        }
        setReloadParentData()
    }

    const onMacroarea = (macroarea: string) => {
        setMacroareaMap((map) => ({
            ...map,
            [uploadedImageList[slide].attachmentId]: macroarea,
        }))
    }

    const onFixtureCount = (fixtureCount: string) => {
        setFixtureCountMap((map) => ({
            ...map,
            [uploadedImageList[slide].attachmentId]: fixtureCount,
        }))
    }

    const finalCallback = () => {
        setUploadedImageList([])
        showToastSavePictureSuccess()
        setReloadParentData()
        onClose()
    }

    const onSave = (callback?: (attachmentIds: string[]) => void) => {
        if (canGalleryPhotoPublish() && uploadedImageList.length > 20) {
            setDialogConfirmPublishPhotoVisible(true)
            return
        }
        uploadActivityTaskPhoto(
            uploadedImageList.map((image) => {
                const img: TaskPhotoUpload = {
                    attachment: { id: image.attachmentId },
                    macroarea: macroareaMap[image.attachmentId],
                    fixtureCount: fixtureCountMap[image.attachmentId],
                    storeId: storeId[image.attachmentId],
                }
                if (!!localProjectid) img.projectId = localProjectid
                return img
            }),
            () => {
                callback && callback(uploadedImageList.map((image) => image.attachmentId))
                finalCallback()
            }
        )
    }

    const onConfirmPublishPhoto = () => {
        setDialogConfirmPublishPhotoVisible(false)
        onSave()
    }

    const onDownload = () => {
        downloadPhoto(uploadedImageList[slide]?.url, uploadedImageList[slide]?.name)
    }

    const onConfirmDelete = () => {
        setUploadedImageList(
            uploadedImageList.filter((i) => i.name !== uploadedImageList[slide].name)
        )
        setDialogConfirmDeletePhotoVisible(false)
    }

    const ctaHandler = (action) => {
        switch (action) {
            case SavePictureActions.DOWNLOAD:
                onDownload()
                break
            case SavePictureActions.GO:
                approvePhoto([id])
                break
            case SavePictureActions.STOP:
                rejectPhoto([id])
                break
            case SavePictureActions.PUBLISH:
                publishPhoto([id])
                break
            case SavePictureActions.SEND_IN_APPROVAL:
                sendInApprovalPhoto([id])
                break
            case SavePictureActions.ADD_TO_ALBUM:
                setAlbumListDialogVisible(true)
                break
            case SavePictureActions.DELETE_FROM_PICSTORE:
                deletePhoto([id], () => onClose())
                break
            case SavePictureActions.RETAKE_PHOTO:
                setImagePosition(slide + 1)
                setDialogUploadPhotoVisible(true)
                break
            case SavePictureActions.SAVE:
                onSave()
                break
            case SavePictureActions.SAVE_AND_PUBLISH:
                onSave(publishPhoto)
                break
            case SavePictureActions.SAVE_AND_SEND_IN_APPROVAL:
                onSave(sendInApprovalPhoto)
                break
        }
    }

    const initFixtureCountMap = () => {
        if (uploadedImageList[slide]) {
            setFixtureCountMap((map) => ({
                ...map,
                [uploadedImageList[slide].attachmentId]:
                    map[uploadedImageList[slide].attachmentId] || 1,
            }))
        }
    }

    ///// TEMPLATES /////

    const sidebar = (
        <div className="sidebar-content">
            <div className="photo-info-container">
                {!isUpload && !!photoDetails && (
                    <PhotoDetails details={photoDetails} goToReferenceTask={goToReferenceTask} />
                )}
                {isUpload && (
                    <PhotoDetailsUpload
                        imageId={uploadedImageList[slide]?.attachmentId}
                        storeId={storeId[uploadedImageList[slide]?.attachmentId]}
                        projectType={projectType}
                        projectTitle={projectTitle}
                        isStore={uploadStoreId}
                        disclaimer={intl.formatMessage({
                            id: 'ph2.modals.gallery.detail.save_picture.task.sidebar.disclaimer',
                            defaultMessage:
                                'Fill the following info to categorize and store your picture.',
                        })}
                        macroArea={macroareaMap[uploadedImageList[slide]?.attachmentId]}
                        onMacroArea={onMacroarea}
                        fixtureCount={fixtureCountMap[uploadedImageList[slide]?.attachmentId]}
                        onFixtureCount={onFixtureCount}
                        setProjectId={projectId ? null : setLocalProjectId}
                        setStoreId={(v) =>
                            setStoreId((s) => ({
                                ...s,
                                [uploadedImageList[slide]?.attachmentId]: v,
                            }))
                        }
                    />
                )}
            </div>
        </div>
    )

    const footer = (
        <>
            {!isUpload && photoDetails && (
                <LuxCtaGroupWrapper
                    ctaConfig={getCtaConfig(photoDetails, intl)}
                    componentClass={componentClass}
                    ctaHandler={ctaHandler}
                    linkText="options"
                    buttonText="Actions"
                />
            )}
            {isUpload && (
                <div className={`${componentClass}__footer`}>
                    <LuxCtaGroupWrapper
                        ctaConfig={getCtaNewPhotoConfig(intl)}
                        componentClass={componentClass}
                        ctaHandler={ctaHandler}
                        linkText="options"
                        buttonText="Actions"
                    />
                </div>
            )}
        </>
    )

    ////// EFFECTS /////

    useEffect(() => {
        if (!!id) {
            getPhotoDetails(id)
        }
        const activityBreadcrumbClick = () => {
            onClose()
        }
        let activityBreadcrumbSelector = document.querySelector(
            '.smart-wardrobe-modal-fullscreen__breadcrumb  nav ul'
        )
        activityBreadcrumbSelector.addEventListener('click', activityBreadcrumbClick)
        return () => {
            activityBreadcrumbSelector.removeEventListener('click', activityBreadcrumbClick)
        }
    }, [])

    useEffect(() => {
        if (photoDetails) {
            setUploadedImageList([
                {
                    name: `${photoDetails.name}.${photoDetails.ext}`,
                    url: photoDetails.url,
                    attachmentId: photoDetails._id,
                    ext: photoDetails.ext,
                    date: photoDetails.insertDate,
                },
            ])
        }
    }, [photoDetails])

    useEffect(() => {
        setMobileImageList(
            uploadedImageList.map((i) => ({
                photo: {
                    url: i.url,
                },
                actions: [
                    {
                        label: 'expand',
                        icon: 'expand',
                        command: onExpandImage.bind(null, {
                            url: uploadedImageList[slide]?.url,
                            name: uploadedImageList[slide]?.name,
                        }),
                    },
                    {
                        label: 'delete',
                        icon: 'trash',
                        command: (val) => setDialogConfirmDeletePhotoVisible(true),
                    },
                ],
            }))
        )
        if (slide > 0 && !uploadedImageList[slide]) setSlide(slide - 1)
        initFixtureCountMap()
    }, [uploadedImageList])

    useEffect(() => {
        if (!!uploadedImageList[slide]) {
            setMacroareaMap((map) => ({
                ...map,
                [uploadedImageList[slide].attachmentId]:
                    map[uploadedImageList[slide].attachmentId] || '',
            }))
            initFixtureCountMap()
        }
    }, [slide])

    return (
        <div className={componentClass}>
            <LuxModalFullScreen
                footer={footer}
                sidebar={sidebar}
                onClose={onClose.bind(null, executionProjectId)}
                breadcrumbMenu={breadcrumbs}
                labelHeaderMobile={'Picture ID'}>
                <div className={`${componentClass}__content`}>
                    <PhotoSlider
                        slide={slide}
                        uploadedImageList={uploadedImageList}
                        mobileImageList={mobileImageList}
                        hideAddPhoto={!isUpload}
                        onDownload={onDownload}
                        onTag={onTag}
                        onEdit={onEdit}
                        onDelete={() => {
                            setDialogConfirmDeletePhotoVisible(true)
                        }}
                        onAddPhoto={() => setDialogUploadPhotoVisible(true)}
                        onExpandImage={onExpandImage}
                        previousImage={previousImage}
                        nextImage={nextImage}
                        onSwiperActiveIndexChange={(swiper) => setSlide(swiper.activeIndex)}
                    />
                    {isMobile && (
                        <div className={`${componentClass}__sidebar-mobile`}>{sidebar}</div>
                    )}
                </div>
                {showPhotoFullScreen && (
                    <LuxPhotoFullScreen
                        selectedImage={selectedImage}
                        tagList={tagList}
                        tagOnImageList={tagOnImageList}
                        newTagPosition={newTagPosition}
                        imageInfo={selectedImageInfo}
                        enabledTag={enabledTag}
                        enabledEdit={enabledEdit}
                        totalImage={uploadedImageList.length}
                        editLoading={editLoading}
                        intl={intl}
                        disableInfo
                        setEditLoading={setEditLoading}
                        onClose={onCloseFullScreen}
                        onNewTagPosition={onNewTagPosition}
                        onRemoveTag={onRemoveTag}
                        onEditDone={onEditDone}
                        previousImage={previousImage}
                        nextImage={nextImage}
                    />
                )}
                <DialogUploadPhoto
                    visible={dialogUploadPhotoVisible}
                    multiple={!imagePosition}
                    projectName={projectTitle}
                    modalLoading={modalLoading}
                    onFileChange={onFileChange}
                    onHide={() => setDialogUploadPhotoVisible(false)}
                />
                <DialogConfirmDeletePhoto
                    visible={dialogConfirmDeletePhotoVisible}
                    onHide={() => setDialogConfirmDeletePhotoVisible(false)}
                    onConfirm={onConfirmDelete}
                />
                <DialogConfirmPublishPhoto
                    totalPhoto={uploadedImageList.length}
                    visible={dialogConfirmPublishPhotoVisible}
                    onHide={() => setDialogConfirmPublishPhotoVisible(false)}
                    onConfirm={onConfirmPublishPhoto}
                />
                {albumListDialogVisible && (
                    <AlbumListDialog
                        selectedPhotosIds={uploadedImageList.map((a) => a.attachmentId)}
                        visible={albumListDialogVisible}
                        close={() => {
                            setAlbumListDialogVisible(false)
                        }}
                    />
                )}
            </LuxModalFullScreen>
        </div>
    )
}

const mapStateToProps = (state: any) => ({
    imageProps: state.layoutReducer.modals?.props ?? {},
    modalLoading: state.layoutReducer.modals.props?.loading,
    photoDetails: state[SAVE_PICTURE_REDUCER_NAMESPACE].photoDetails,
    tagListApi: state[FILTERS_REDUCER_NAMESPACE].tags,
})

const mapDispatchToProps = (dispatch: any) => ({
    onClose: (executionProjectId: string) => {
        if (!executionProjectId) {
            dispatch(
                layoutActions.setModals({
                    type: null,
                    props: {
                        id: null,
                        storeIdList: null,
                        isEdit: false,
                        isClone: false,
                        projectTitle: null,
                        projectType: null,
                        projectId: null,
                        isUpload: false,
                        imageList: [],
                        storesList: [],
                        uploadStoreId: null,
                    },
                })
            )
            dispatch(setPhotoDetials(null))
            return
        }
        dispatch(
            layoutActions.setModals({
                type: ModalsType.TASK_EXECUTION,
                props: {
                    id: executionProjectId,
                    storeIdList: null,
                    isEdit: false,
                    isClone: false,
                    projectTitle: null,
                    projectType: null,
                    projectId: null,
                    isUpload: false,
                    imageList: [],
                    storesList: [],
                },
            })
        )
    },
    uploadActivityTaskPhoto: (photos: TaskPhotoUpload[], callback: () => void) =>
        dispatch(uploadActivityTaskPhoto(photos, callback)),
    approvePhoto: (attachmentIds: string[]) => dispatch(approvePhoto(attachmentIds)),
    rejectPhoto: (attachmentIds: string[]) => dispatch(rejectPhoto(attachmentIds)),
    publishPhoto: (attachmentIds: string[]) => dispatch(publishPhoto(attachmentIds)),
    sendInApprovalPhoto: (attachmentIds: string[]) => dispatch(sendInApprovalPhoto(attachmentIds)),
    deletePhoto: (attachmentIds: string[], callback: () => void) =>
        dispatch(deletePhoto(attachmentIds, callback)),
    getPhotoDetails: (id: string) => dispatch(getPhotoDetails(id)),
    newActivityCreationError: (err) => dispatch(newActivityCreationError(err)),
    setModalLoading: (loading) => dispatch(layoutActions.setModals({ props: { loading } })),
    goToReferenceTask: (id: string, storeId: string) => {
        dispatch(
            layoutActions.setModals({
                type: null,
                props: { goToReferenceTask: id, storeId },
            })
        )
    },
    showToastSavePictureSuccess: () => dispatch(showToastSavePictureSuccess()),
    setReloadParentData: () => setReloadParentData({ dispatch }),
    getPhotoTagList: () => dispatch(getPhotoTagList()),
    updatePhotoTagList: (
        params: {
            attachmentId: string
            tags: { name: string; x: number; y: number }[]
        },
        callback: () => void
    ) => dispatch(updatePhotoTagList(params, callback)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SavePicture)
